/**
 * No Visit Closed Trigger Component
 *
 * Trigger: "has not closed out a visit in"
 * Interval fields (delay interval + type) are rendered by TimingSection at card level.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const NoVisitClosedTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.hasNotClosedVisit')}</span>;
  }

  // Edit mode - no additional fields, timing handled at card level
  return null;
};
